import { CrosswalkInput, LocationInput, LaneInput } from '@kinetic-ui/data-layer';
import { movePointGeometry, moveLineGeometry } from 'kineticUtils/data/geometry';

export const moveLocationGeometry = ({
  location,
  distance,
  bearing,
}: {
  location: LocationInput;
  distance: number;
  bearing: number;
}): LocationInput => {
  const { geometry, lanes, crosswalks } = location;
  const { coordinates } = geometry;
  return {
    ...location,
    geometry: {
      ...location.geometry,
      coordinates: movePointGeometry({
        coordinates,
        distance,
        bearing,
      }),
    },
    lanes: lanes.map(({ geometry, ...lane }): LaneInput => {
      const { coordinates } = geometry;
      return {
        ...lane,
        geometry: {
          ...geometry,
          coordinates: moveLineGeometry({
            line: coordinates as [number, number][],
            distance,
            bearing,
          }),
        },
      };
    }),
    crosswalks: crosswalks.map(({ geometry, ...crosswalk }): CrosswalkInput => {
      const { coordinates } = geometry;
      return {
        ...crosswalk,
        geometry: {
          ...geometry,
          coordinates: moveLineGeometry({
            line: coordinates as [number, number][],
            distance,
            bearing,
          }),
        },
      };
    }),
  };
};
